import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, ExternalLink, Handshake, Loader2 } from "lucide-react";
import { partnerService, resolveImageUrl } from "../services/catalogService";
import { useLanguage } from "../context/LanguageContext";

// Task 13 — dedicated partners/collaborators gallery (admin-managed).
export default function PartnersPage() {
  const { t } = useLanguage();
  const [partners, setPartners] = useState(null);

  useEffect(() => {
    partnerService.list().then(setPartners).catch(() => setPartners([]));
  }, []);

  return (
    <main className="min-h-screen bg-[#F6F2EC] text-[#252525] pt-28 pb-24" data-testid="partners-page">
      <div className="container-tessa">
        <Link to="/" className="flex w-fit items-center gap-2 text-[12px] uppercase tracking-[0.16em] text-[#817B74] hover:text-[#D92A47] transition-colors mb-10">
          <ArrowLeft size={14} /> {t("pages.backHome")}
        </Link>
        <span className="font-sans text-xs uppercase tracking-[0.24em] text-[#D92A47]">{t("pages.partners.eyebrow")}</span>
        <h1 className="font-serif text-5xl md:text-6xl leading-[0.95] mt-3">
          {t("pages.partners.title")}
        </h1>
        <p className="text-[#817B74] mt-4 max-w-xl">
          {t("pages.partners.subtitle")}
        </p>

        {partners === null ? (
          <div className="text-[#817B74] py-20 text-center"><Loader2 className="animate-spin inline mr-2" size={16} />{t("pages.loading")}</div>
        ) : partners.length === 0 ? (
          <div className="border border-black/10 bg-white p-12 text-center mt-10" data-testid="partners-empty">
            <Handshake size={26} strokeWidth={1.4} className="mx-auto mb-3 text-[#D92A47]" />
            <p className="font-serif text-2xl">{t("pages.partners.emptyTitle")}</p>
            <p className="text-[#817B74] mt-2">{t("pages.partners.emptyText")}</p>
          </div>
        ) : (
          <ul className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 mt-12" data-testid="partners-list">
            {partners.map((p) => {
              const card = (
                <>
                  <div className="h-32 grid place-items-center px-6 bg-white">
                    {p.logo ? (
                      <img src={resolveImageUrl(p.logo)} alt={p.name} className="max-h-20 max-w-full object-contain" />
                    ) : (
                      <span className="font-serif text-2xl text-[#252525]">{p.name}</span>
                    )}
                  </div>
                  <div className="border-t border-black/10 px-4 py-3 flex items-center justify-between gap-2">
                    <div className="min-w-0">
                      <p className="font-medium text-sm text-[#252525] truncate">{p.name}</p>
                      {p.country && <p className="text-[11px] uppercase tracking-[0.12em] text-[#817B74]">{p.country}</p>}
                    </div>
                    {p.website && <ExternalLink size={14} className="text-[#817B74] shrink-0" />}
                  </div>
                </>
              );
              return (
                <li key={p.id} data-testid={`partner-card-${p.id}`}>
                  {p.website ? (
                    <a href={p.website} target="_blank" rel="noreferrer"
                      className="block border border-black/10 bg-white hover:border-[#D92A47] transition-colors">
                      {card}
                    </a>
                  ) : (
                    <div className="border border-black/10 bg-white">{card}</div>
                  )}
                </li>
              );
            })}
          </ul>
        )}
      </div>
    </main>
  );
}
